(function () {

    "use strict";

    angular
        .module("parLabor")
        .component("manageParLaborComponent", {
            controller: ManageParLaborComponent,
            bindings: {
                data: '<',
                week: '<',
                forecastId: '<'
            },
            controllerAs: 'manageParLaborComponent',
            templateUrl: '../hmodules/par-labor/components/manage-par-labor/manage-par-labor.component.html'
        });

    ManageParLaborComponent.$inject = ['$scope', '$modal', 'TeamScheduleService', 'ParLaborDataService', '$filter', '$state', 'userServices'];

    function ManageParLaborComponent ($scope, $modal, TeamScheduleService, ParLaborDataService, $filter, $state, userServices) {

        var self = this;
        self.manageParLaborForm = {};
        BaseForm.call(self.manageParLaborForm, "manage-par-labor-form", $scope);

        self.weekTotalSales = 0;
        self.foodSalesTotal = 0;
        self.parTypes = [
            {
                value: 'PAR',
                name: 'PAR'
            }
        ];

        var DEFAULT_POSITIONS_ROWS = 3;
        var positionsForecasts;
        var originData = {};

        var initCreateParLabor = function (startOfWeek) {
            ParLaborDataService
                .getBrandSales(startOfWeek)
                .then(function (brandSales) {
                    var revenueCentersSales = brandSales['revenue_centers'] || [];

                    for (var i in revenueCentersSales) {
                        var revenueSales = revenueCentersSales[i];

                        for (var j in revenueSales.days) {
                            var daySales = revenueSales.days[j];
                            var date = $filter('formatDateIgnoreTimeZone')(daySales.date, "YYYY-MM-DD");

                            self.data.weekSales[j] = self.data.weekSales[j] || {'total_sales': 0, 'date': date};
                            self.data.weekSales[j].total_sales += ((daySales.total_sales || 0) / 100);
                            self.weekTotalSales += ((daySales.total_sales || 0) / 100);
                        }
                    }

                    if (self.data.weekSales.length === 0) {
                        var startOfWeek = moment(self.week);

                        for (var i = 0; i < 7; i++) {
                            self.data.weekSales[i] =  {'total_sales': 0, 'date': startOfWeek.format("YYYY-MM-DD")};
                            self.data.weekSales[i].total_sales = 0;
                            startOfWeek.add(1, 'day');
                        }
                    }

                    for (var i = 0; i < DEFAULT_POSITIONS_ROWS; i++) {
                        self.addNewPosition();
                    }

                    positionsForecasts = angular.copy(self.data.positionsParForecasts);
                    originData = angular.copy(self.data);
                })
                .finally(function () {
                    delete self.loading;
                    self.manageParLaborForm.onViewLoaded();
                });
        };

        var initParForecast = function () {
            ParLaborDataService
                .getWeekParForecast(self.forecastId)
                .then(function (forecasts) {
                    self.data = $.extend(self.data, forecasts);

                    self.data.weekSales.sort(function (day_1, day_2) {
                        return moment(day_1.date).isAfter(day_2.date) ? 1 : -1;
                    });

                    if (self.data.numberOfFilledPositions < 3) {
                        for (var i = 0; i < (DEFAULT_POSITIONS_ROWS - self.data.numberOfFilledPositions); i++) {
                            self.addNewPosition();
                        }
                    }

                    positionsForecasts = angular.copy(self.data.positionsParForecasts);
                    originData = angular.copy(forecasts);

                    self.updateTotals();

                    self.selectedPositions = updateSelectedPositionsList();

                    for (var i in self.data.positionsParForecasts) {
                        self.numberOfShiftsChanged(i);
                    }
                }, function (err) {
                    console.error(err);
                    $state.go("appLayout.schedule.par-labor");
                })
                .finally(function () {
                    delete self.loading;
                    self.manageParLaborForm.onViewLoaded();
                });
        };

        var init = function () {
            self.loading = true;
            self.isPositionSelected = true;

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    self.currency = $filter("locationCurrencySymbol")(brand);
                    self.dayParts = brand['day_parts'] || [];
                    self.activeDayParts = [];

                    for (var i in self.dayParts) {
                        var dayPart = self.dayParts[i];

                        if (dayPart.status === 'ACTIVE') {
                            self.activeDayParts.push(dayPart);
                        }
                    }

                    if (self.activeDayParts.length) {
                        self.parTypes.push({
                            value: 'PAR_DAY_PART',
                            name: 'PAR Day Part'
                        });
                    }

                    ParLaborDataService
                        .getBrandUserPositions()
                        .then(function (res) {
                            var positionCategories = res['position_categories'] || [];
                            self.positions = [];

                            for (var i in positionCategories) {
                                var category = positionCategories[i];

                                self.positions = self.positions.concat(category.positions);
                            }

                            self.positions.sort(function (pos1, pos2) {
                                return pos1.name > pos2.name ? 1 : -1;
                            });

                            // if forecast Id not null, means edit mode
                            if (self.forecastId) {
                                initParForecast();
                            } else {
                                initCreateParLabor(self.week);
                            }
                        });
                });
        };

        self.updateFoodTotal = function () {
            self.foodSalesTotal = parseFloat(self.weekTotalSales) * (parseFloat(self.data.food_sales_percentage || 0) / 100);
        };

        self.updateTotals = function () {
            self.weekTotalSales = 0;

            for (var i in self.data.weekSales) {
                var daySales = self.data.weekSales[i];

                self.weekTotalSales += parseFloat(daySales.total_sales || 0);
            }

            self.foodSalesTotal = parseFloat(self.weekTotalSales) * (parseFloat(self.data.food_sales_percentage || 0) / 100);
        };

        // if par type = par day part, add new objects to positionsParForecasts array
        // the number of new objects equal to brand day parts
        // if par type = par, remove all other object that have same position
        self.selectPositionParType = function (index, positionForecast, parType) {
            if (positionForecast.par_type.value === parType.value) {
                return;
            }

            positionForecast.par_type = parType;

            if (parType.value === 'PAR_DAY_PART') {
                self.data.positionsParForecasts.splice(index, 1);

                for (var i in self.activeDayParts) {
                    var dayPart = self.activeDayParts[i];

                    var newForecast = {
                        position: positionForecast.position,
                        par_type: parType,
                        day_part: dayPart,
                        totalShifts: 0,
                        days: [
                            {'number_of_shifts': 0},
                            {'number_of_shifts': 0},
                            {'number_of_shifts': 0},
                            {'number_of_shifts': 0},
                            {'number_of_shifts': 0},
                            {'number_of_shifts': 0},
                            {'number_of_shifts': 0}
                        ]
                    };

                    self.data.positionsParForecasts.splice(index++, 0, newForecast);
                }
            } else {
                var forecasts = [];

                // reset number of shifts for this position
                for (var i in positionForecast.days) {
                    var day = positionForecast.days[i];

                    day.number_of_shifts = 0;
                }

                positionForecast['day_part'] = {
                    name: 'PAR',
                    id: null
                };

                self.numberOfShiftsChanged(index);

                for (var j in self.data.positionsParForecasts) {
                    var forecast = self.data.positionsParForecasts[j];

                    if (j == index || ((forecast.position && forecast.position.code) !== (positionForecast.position && positionForecast.position.code))) {
                        forecasts.push(forecast);
                    }
                }

                self.data.positionsParForecasts = forecasts;
            }

            positionsForecasts = angular.copy(self.data.positionsParForecasts);
        };

        var updateSelectedPositionsList = function () {
            var positionsCodes = [];

            for (var i in self.data.positionsParForecasts) {
                var forecast = self.data.positionsParForecasts[i];

                if (forecast.position && forecast.position.code && (positionsCodes.indexOf(forecast.position.code) === -1)) {
                    positionsCodes.push(forecast.position.code);
                }
            }


            return positionsCodes;
        };

        // if position de-selected or changed, reset par type to default [PAR]
        // and reset number of shifts per day
        self.positionChanged = function (index, positionForecast) {
            var oldForecast = positionsForecasts[index];
            var forecasts = [];

            // if position was selected and the position selected not equal current position
            if (oldForecast) {
                if (oldForecast.position && oldForecast.position.code !== (positionForecast.position && positionForecast.position.code)) {
                    positionForecast['par_type'] = {
                        value: 'PAR',
                        name: 'PAR'
                    };

                    positionForecast['day_part'] = {
                        name: 'PAR',
                        id: null
                    };

                    for (var j in positionForecast.days) {
                        var day = positionForecast.days[j];

                        day.number_of_shifts = 0;
                    }

                    self.numberOfShiftsChanged(index);

                    for (var i in self.data.positionsParForecasts) {
                        var forecast = self.data.positionsParForecasts[i];

                        if (i == index || ((forecast.position && forecast.position.code) !== oldForecast.position.code)) {
                            forecasts.push(forecast);
                        }
                    }

                    self.data.positionsParForecasts = forecasts;
                    positionsForecasts = angular.copy(self.data.positionsParForecasts);
                }
            }

            //updated selected positions list to disable selected positions
            self.selectedPositions = updateSelectedPositionsList();

            if (positionForecast && !self.isPositionSelected) {
                self.isPositionSelected = true;
            }
        };

        self.numberOfShiftsChanged = function (index) {
            var forecast = self.data.positionsParForecasts[index];
            forecast.totalShifts = 0;

            for (var i in forecast.days) {
                forecast.totalShifts += parseFloat(forecast.days[i].number_of_shifts || 0);
            }
        };

        self.addNewPosition = function () {
            var newForecast = {
                position: null,
                par_type: {
                    value: 'PAR',
                    name: 'PAR'
                },
                day_part: {
                    name: 'PAR',
                    id: null
                },
                totalShifts: 0,
                days: [
                    {'number_of_shifts': 0},
                    {'number_of_shifts': 0},
                    {'number_of_shifts': 0},
                    {'number_of_shifts': 0},
                    {'number_of_shifts': 0},
                    {'number_of_shifts': 0},
                    {'number_of_shifts': 0}
                ]
            };

            self.data.positionsParForecasts.push(newForecast);
        };

        self.saveAsTemplate = function () {

        };

        self.discard = function () {
            self.data = angular.copy(originData);
            self.updateTotals();

            for (var i in self.data.positionsParForecasts) {
                self.numberOfShiftsChanged(i);
            }

            positionsForecasts = angular.copy(self.data.positionsParForecasts);

            self.selectedPositions = updateSelectedPositionsList();
            self.manageParLaborForm.validator.validation = {};
            self.isPositionSelected = true;
        };

        self.save = function () {
            var parForecast = ParLaborDataService.prepareSavedData(self.data, self.forecastId, self.week);
            self.isPositionSelected = !!parForecast.days.length;

            var isValid = self.manageParLaborForm.validator.validate();

            if (isValid && self.isPositionSelected) {
                self.saving = true;

                var promise;

                if (self.forecastId) {
                    promise = ParLaborDataService.updateParForecast(self.forecastId, parForecast)

                } else {
                    promise = ParLaborDataService.createParForecast(parForecast);
                }

                promise
                    .then(function (res) {
                        self.forecastId = self.forecastId || res['par_forecast'].id;
                        originData = angular.copy(self.data);
                        delete self.saving;

                        HNotifications.show({
                            title: $filter("translate")("Success"),
                            desc: $filter("translate")("Par labor forecast saved successfully!"),
                            icon: "fa-check-circle",
                            type: "success"
                        });

                    }, function (err) {
                        delete self.saving;
                        console.error(err);
                    });
            }
        };

        var onBrandChangedHandler = TeamScheduleService.onBrandChanged(function (brand, newBrand) {
            userServices
                .isServiceEnabled(userServices.SERVICES.PAR_LABOR, newBrand.id)
                .then(function (isParLaborServiceEnabled) {
                    if (isParLaborServiceEnabled) {
                        if (newBrand.startDayOfWeek === moment(self.week).format('ddd')) {
                            self.weekTotalSales = 0;
                            self.foodSalesTotal = 0;
                            positionsForecasts = {};
                            originData = {};

                            self.$onInit();
                        } else {
                            $state.go("appLayout.schedule.par-labor");
                        }

                    } else {
                        $state.go("appLayout.schedule.main");
                    }
                });
        });

        self.$onInit = function () {
            self.data.weekSales = [];
            self.data.positionsParForecasts = [];
            self.data.food_sales_percentage = 0;

            init();
        };

        var isActivePosition = function (positionCode) {
            var isActivePosition = false;

            for (var i in self.positions) {
                var position = self.positions[i];

                if (positionCode == position.code) {
                    isActivePosition = true;
                    break;
                }
            }

            return isActivePosition;
        };

        self.$onChanges = function (changesObj) {

            if (JSON.stringify(changesObj.data.currentValue) !== JSON.stringify(changesObj.data.previousValue)) {

                self.data.weekSales.sort(function (day_1, day_2) {
                    return moment(day_1.date).isAfter(day_2.date) ? 1 : -1;
                });

                for (var j in self.data.positionsParForecasts) {
                    var positionForecast = self.data.positionsParForecasts[j];

                    if (
                        (positionForecast.position && !isActivePosition(positionForecast.position.code)) ||
                        (positionForecast.day_part && positionForecast.day_part.status === 'INACTIVE')
                    ) {

                        self.data.positionsParForecasts[j] = {
                            position: null,
                            par_type: {
                                value: 'PAR',
                                name: 'PAR'
                            },
                            day_part: {
                                name: 'PAR',
                                id: null
                            },
                            totalShifts: 0,
                            days: [
                                {'number_of_shifts': 0},
                                {'number_of_shifts': 0},
                                {'number_of_shifts': 0},
                                {'number_of_shifts': 0},
                                {'number_of_shifts': 0},
                                {'number_of_shifts': 0},
                                {'number_of_shifts': 0}
                            ]
                        };
                    }
                }

                if (self.data.numberOfFilledPositions < 3) {
                    for (var i = 0; i < (DEFAULT_POSITIONS_ROWS - self.data.numberOfFilledPositions); i++) {
                        self.addNewPosition();
                    }
                }

                positionsForecasts = angular.copy(self.data.positionsParForecasts);

                self.updateTotals();

                self.selectedPositions = updateSelectedPositionsList();

                for (var i in self.data.positionsParForecasts) {
                    self.numberOfShiftsChanged(i);
                }
            }
        };

        self.$onDestroy = function () {
            TeamScheduleService.off(onBrandChangedHandler);
        };
    }

})();